/* eslint-disable import/no-unresolved */

import { createVueApp } from '@vuejs/entry';
import { sharedPinia } from '@vuejs/pinia';

async function mountKluczykiApp() {
    const mountEl = document.querySelector('#kluczyki-app');

    if (!mountEl) {
        return;
    }

    const configEl = document.getElementById('kluczyki-config');

    if (!configEl) {
        return;
    }

    let config = {};
    try {
        config = JSON.parse(configEl.textContent);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Invalid kluczyki config JSON', err);
        return;
    }

    const { default: KluczykiLandingApp } = await import(
        /* webpackChunkName: "KluczykiLandingApp" */ '@vuejs/apps/landing/KluczykiLandingApp.vue'
    );

    const app = createVueApp(KluczykiLandingApp);
    app.use(sharedPinia);
    app.provide('kluczykiConfig', config);

    const point = mountEl.querySelector('[data-vue-mount]') || mountEl;
    app.mount(point);
}

function initFaq(root) {
    root.querySelectorAll('[data-kth-faq]').forEach((item) => {
        item.addEventListener('click', () => {
            item.classList.toggle('is-open');
        });
    });
}

function initRevealAnimations(root) {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                }
            });
        },
        { threshold: 0.1, rootMargin: '0px 0px -100px 0px' }
    );

    root.querySelectorAll('section:not(.kth-product-card)').forEach((el) => {
        el.classList.add('kth-reveal');
        observer.observe(el);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.keys-to-happiness');

    if (!root) {
        return;
    }

    initFaq(root);
    initRevealAnimations(root);
    mountKluczykiApp();
});
